/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeDRadiusUpLeftIcon16Solid = forwardRef('ArrowShapeDRadiusUpLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 1.982c0-.846-1.023-1.27-1.622-.672L.574 7.115a1.25 1.25 0 0 0 0 1.768l5.804 5.805c.599.599 1.622.175 1.622-.672v-2.758c1.41.034 2.28.176 2.996.505.83.38 1.543 1.05 2.643 2.367a.75.75 0 0 0 1.324-.428c.225-3.158-.585-5.435-2.095-6.915C11.555 5.497 9.802 4.9 8 4.776V1.982Z" })));
});
